<template>
  <button id="clean-chips-button" aria-label="Clear filters" @click="e => $emit('click', e)">
    <label for="clean-chips-button" class="iw-visuallyhidden">Clear filters</label>
    <div class="clean-chips-button__overlay" />
    <div class="clean-chips-button__xIcon">
      <svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 11 11">
        <g fill="none" fill-rule="evenodd">
          <g fill="currentColor" fill-rule="nonzero" stroke="currentColor" stroke-width=".5">
            <path
              d="M20.885 12.116c-.154-.155-.36-.155-.513 0L16.5 15.993l-3.872-3.877c-.154-.155-.359-.155-.513 0-.153.154-.153.359 0 .513l3.872 3.877-3.872 3.878c-.153.154-.153.36 0 .513.077.077.154.103.257.103.102 0 .18-.026.256-.103L16.5 17.02l3.872 3.877c.077.077.154.103.256.103.103 0 .18-.026.257-.103.153-.154.153-.36 0-.513l-3.872-3.878 3.872-3.877c.128-.128.128-.36 0-.513z"
              transform="translate(-18.000000, -198.000000) translate(7.000000, 187.000000)"
            />
          </g>
        </g>
      </svg>
    </div>
  </button>
</template>

<script>
export default {
  name: "CleanChipsButton"
};
</script>

<style scoped lang="scss">
#clean-chips-button {
  position: relative;
  display: flex;
  cursor: pointer;
  font-weight: $font_regular;
  box-sizing: border-box;
  width: 32px;
  height: 32px;
  border-radius: 20px;
  background-color: $group-3-color-1;

  display: block;
  align-items: center;
  align-content: center;
  justify-content: center;
  border: none;

  &__xIcon {
    color: $group-3-color-2;
  }

  &__overlay {
    position: absolute;
    top: 0;
    left: 0;
    border: none;
    border-radius: inherit;
    outline: none;
    width: 100%;
    height: 100%;
  }

  @include hover-supported() {
    &:hover {
      .clean-chips-button__overlay {
        opacity: 0.04;
        background-color: $group-3-color-4;
      }
    }
  }

  &:active {
    .clean-chips-button__overlay {
      opacity: 0.1;
      background-color: #000;
    }
  }
}
</style>
